import {Component, OnInit} from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {FormBuilder, FormControl} from '@angular/forms';
import {CustomersService} from '../../home/services/customers.service';
import {UploadDocsService} from '../services/upload.service';
import {ConfirmDialogComponent} from '../../shared/confirm-dialog/confirm-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';


@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})

export class UploadComponent implements OnInit {


  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private customerService: CustomersService,
    private formBuilder: FormBuilder,
    private router: Router,
    private uploadService: UploadDocsService,
    private dialog: MatDialog
  ) {
    translate.onLangChange.subscribe((e: LangChangeEvent) => {
        this._currentLanguage = translate.currentLang;
      }
    );

    this._currentLanguage = translate.currentLang;

  }


  _currentLanguage;
  token: string;
  // Typ 1 : IDV
  // Typ 2 : Docs
  // Typ 3 : Address
  // Typ 4 : Sof Generic
  // Typ 5 : Sof Single
  // Typ 6 : Address confirmation
  type = 999999;
  finished = false;
  disabled = false;
  showUploadError = false;
  isUploading = false;
  isActive = false;
  notActiveAnymore = false;
  public docTypeSelected = new FormControl();

  files: File[] = [];
  filesBack: File[] = [];
  filesFront: File[] = [];


  ngOnInit() {

    this.token = this.route.snapshot.paramMap.get('token');
    this.uploadService.getInfos(this.token).subscribe(result => {
        this.type = result;
        this.isActive = true;
      },
      error => {

        if (error.error === 'not-active') {
          this.type = 0;
          this.notActiveAnymore = true;
        } else {
          this.type = 0;
        }
        this.isActive = false;

      });
  }


  onDocTypeChanged() {
    this.files = [];
    this.filesBack = [];
    this.filesFront = [];
  }

  onSelect(event) {
    // console.log(event);
    let ok = true;

    if (this.type == 1 && this.files.length >= 1) {
      ok = false;
    }

    if (ok) {
      this.files.push(...event.addedFiles);
    } else {
      this.files = [];
      this.files.push(...event.addedFiles);
    }

  }

  onBackSelect(event) {
    // console.log(event);
    if (this.filesBack.length >= 1) {
      this.filesBack = [];
    }

    this.filesBack.push(...event.addedFiles);

  }

  onFrontSelect(event) {
    // console.log(event);
    if (this.filesFront.length >= 1) {
      this.filesFront = [];
    }

    this.filesFront.push(...event.addedFiles);
  }


  onRemove(event) {
    // console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  onBackRemove(event) {
    // console.log(event);
    this.filesBack.splice(this.files.indexOf(event), 1);
  }

  onFrontRemove(event) {
    // console.log(event);
    this.filesFront.splice(this.files.indexOf(event), 1);
  }

  upload() {


    this.translate.get(['UPLOADS.CONFIRMATION', 'UPLOADS.CONFIRM_TEXT', 'UPLOADS.CANCEL_TEXT', 'UPLOADS.UPLOADTEXT', 'UPLOADS.FINISHED']).subscribe((res: string[]) => {

      const title = res['UPLOADS.UPLOADTEXT'];
      const text = res['UPLOADS.CONFIRMATION'];

      const confirm = res['UPLOADS.CONFIRM_TEXT'];
      const cancel = res['UPLOADS.CANCEL_TEXT'];

      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title,
          text,
          cancel,
          confirm
        }
      }).afterClosed().subscribe(result => {
        if (result == 'ok') {

          this.showUploadError = false;
          this.isUploading = true;
          this.disabled = true;


          const formData = new FormData();

          if (this.files.length > 0) {
            // other files
            for (let i = 0; i < this.files.length; i++) {
              formData.append('file[]', this.files[i]);
              if (this.type == 2 || this.type == 3 || this.type == 4 || this.type == 5 || this.type == 6) {
                formData.append('docTypes[]', '0');
              } // other
              else if (this.type == 1 && this.docTypeSelected.value == 3) {
                formData.append('docTypes[]', '5');
              } // passport
            }
          }
          if (this.filesFront.length > 0) {

            // frontFiles
            for (let i = 0; i < this.filesFront.length; i++) {
              formData.append('file[]', this.filesFront[i]);
              if (this.type == 1 && this.docTypeSelected.value == 2) {
                formData.append('docTypes[]', '3');
              } // driver license front
              if (this.type == 1 && this.docTypeSelected.value == 1) {
                formData.append('docTypes[]', '1');
              } // id card front
            }
          }
          if (this.filesBack.length > 0) {
            // backFiles
            for (let i = 0; i < this.filesBack.length; i++) {
              formData.append('file[]', this.filesBack[i]);
              if (this.type == 1 && this.docTypeSelected.value == 2) {
                formData.append('docTypes[]', '4');
              } // driver license back
              if (this.type == 1 && this.docTypeSelected.value == 1) {
                formData.append('docTypes[]', '2');
              } // id card back
            }
          }


          this.uploadService.uploadFiles(this.token, formData).subscribe(result => {
              if (result) {
                this.finished = true;
                this.isUploading = false;
                this.disabled = true;
                this.showUploadError = false;
              }
            },
            error => {
              this.showUploadError = true;
              this.isUploading = false;
              this.disabled = false;
            });


        }
      });
    });
  }


  private async readFile(file: File): Promise<string | ArrayBuffer> {
    return new Promise<string | ArrayBuffer>((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = e => resolve((e.target as FileReader).result);

      reader.onerror = e => {
        console.error(`FileReader failed on file ${file.name}.`);
        return reject(null);
      };

      if (!file) {
        console.error('No file to read.');
        return reject(null);
      }

      reader.readAsDataURL(file);
    });
  }


}
